import React from 'react';
import { IndicatorCricle, IndicatorTitle } from './TableRiskIndicatorStyle';

const TableRiskIndicator = title => {
  return /*#__PURE__*/React.createElement("div", {
    display: "flex",
    alignItems: "center",
    paddingLeft: "10px"
  }, title === 'High' ? /*#__PURE__*/React.createElement(IndicatorCricle, {
    style: {
      background: '#4A66F1'
    }
  }) : title === 'Medium' ? /*#__PURE__*/React.createElement(IndicatorCricle, {
    style: {
      background: '#571EB3'
    }
  }) : title === 'Low' ? /*#__PURE__*/React.createElement(IndicatorCricle, {
    style: {
      background: '#0E804B'
    }
  }) : /*#__PURE__*/React.createElement(IndicatorCricle, {
    style: {
      background: '#FFB41E'
    }
  }), /*#__PURE__*/React.createElement(IndicatorTitle, null, title, " "));
};

export default TableRiskIndicator;